import "./page-agriculture.scss";
import "../../js/core";
import {SwiperInit} from '../../components/site-elements/other-blocks/swiper-tabs/swiper-tabs';

SwiperInit("swiper-1");

// Card Slider
function owlInitialize() {
  import(/* webpackChunkName: "chunk.owl-carousel" */ 'owl.carousel/src/js/owl.carousel').then(()=>{
    import(/* webpackChunkName: "chunk.owl-carousel-navigation" */ 'owl.carousel/src/js/owl.navigation').then(()=>{

        if (jQuery(window).width() < 992) {
          jQuery('.js-verticals-slider').owlCarousel({
            responsive: {
              0: {
                dots: false,
                items: 1,
              },
              568: {
                dots: true,
                items: 1,
              },
              768: {
                items: 2,
                dots: true,
                margin: 24,
              },
            },
            nav: true,
            slideBy: 1,
            loop: true,
            dots: false,
            smartSpeed: 200,
          });
          $('.owl-carousel').each(function(index) {
            $(this).find('.owl-nav, .owl-dots').wrapAll("<div class='owl-controls'></div>");
          });
        } else {
          jQuery('.js-verticals-slider').owlCarousel('destroy');
        }
    });
  });
}

owlInitialize();

jQuery(window).on('resize', function() {
  owlInitialize();
});